import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Como um produto que será vendido pela Stefanini no mercado",
    correct: false,
  },
  {
    option:
      "b) Como uma solução embarcada nas nossas ofertas de serviços para aplicações",
    correct: true,
  },
  {
    option:
      "c) Como uma solução para aumento de produtividade em contratos de rate card e bodyshop",
    correct: false,
  },
  {
    option: "d) Como uma ferramenta separada e independente para aquisição",
    correct: false,
  },
  {
    option:
      "e) Como uma atualização gratuita em nosso pacote de serviços existente",
    correct: false,
  },
];

export default function Question1(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question1: {
          title:
            "Como a solução Agiliza Ai deverá ser apresentada aos nossos clientes?",
          option: option.option,
          correct: option.correct,
          order: 1,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Como a solução Agiliza Ai deverá ser apresentada aos nossos clientes?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
